import React from "react";
import {
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
} from "@material-ui/core";
import { Email as EmailIcon } from "@mui/icons-material";
import { CopyIconButton } from "../../CopyIconButton";

export const EmailItem = ({ label, value, copy }) => {
  return (
    <ListItem sx={{ py: 0 }} button href={`mailto:${value}`} component="a">
      <ListItemIcon>
        <EmailIcon />
      </ListItemIcon>
      <ListItemText
        primary={label}
        secondary={value}
        secondaryTypographyProps={{
          sx: {
            wordWrap: "break-word",
          },
        }}
      />
      {copy && (
        <ListItemSecondaryAction>
          <CopyIconButton text={value} edge="end" />
        </ListItemSecondaryAction>
      )}
    </ListItem>
  );
};
